import set_or_update_queryparam from "../../custom_js/set_or_update_queryparam.js";

export default function refineFilters(filterName, filterValue) {
  document
    .querySelectorAll(`input[type="hidden"][name="${filterName}"]`)
    .forEach((hiddenInput) => {
      hiddenInput.value = filterValue;
    });
  document.querySelectorAll(".js-workshop-sorter").forEach((sorter) => {
    const old_link = sorter.getAttribute("href");
    const new_link = set_or_update_queryparam(
      old_link,
      filterName,
      filterValue
    );
    sorter.setAttribute("href", new_link);
  });
}
